import React, { FC } from 'react'
import { Field } from 'react-final-form'
import { useIntl } from 'react-intl'
import { View, ViewStyle } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { requiredFieldErrorMessage } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/messages'
import { CheckboxButtonType } from '@lyrahealth-inc/shared-app-logic/src/models/formMetadata/FormMetadata'

import { CheckboxRFF } from '../../atoms/formElements/Checkbox'
import { AlertLoudIcon } from '../../atoms/icons/AlertLoudIcon'
import { Subhead } from '../../atoms/subhead/Subhead'
import { SubheadSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'
import { InlineBanner } from '../inlineBanner/InlineBanner'

export interface RequiredCheckboxWithBannerProps {
  headerText: string | React.ReactNode
  checkboxLabel: string | React.ReactNode
  checkboxName: string
  bannerText?: string | React.ReactNode
  shouldShowBanner?: boolean
  baseInputStyle?: ViewStyle
}

const HeaderContainer = styled(Subhead)<{ theme: ThemeType }>(({ theme }) => ({
  fontWeight: 500,
  paddingBottom: theme.breakpoints.isMinWidthLaptop ? theme.spacing['16px'] : theme.spacing['24px'],
}))

export const RequiredCheckboxWithBanner: FC<RequiredCheckboxWithBannerProps> = ({
  headerText,
  checkboxLabel,
  checkboxName,
  bannerText,
  shouldShowBanner,
  baseInputStyle,
}) => {
  const intl = useIntl()
  const { colors } = useTheme()

  return (
    <View testID={tID('RequiredCheckboxWithBanner-container')}>
      <HeaderContainer size={SubheadSize.MEDIUM} text={headerText} />
      <Field
        name={checkboxName}
        component={CheckboxRFF}
        buttonType={CheckboxButtonType.CHECKBOX_DESCRIPTION_NO_OUTLINE}
        title={checkboxLabel}
        validate={(value: string | boolean) => (!!value ? undefined : intl.formatMessage(requiredFieldErrorMessage))}
        errorOnSubmitFailed
        baseInputStyle={baseInputStyle}
      />
      {shouldShowBanner && bannerText && (
        <InlineBanner
          testId={tID('RequiredCheckboxWithBanner-banner')}
          text={bannerText}
          backgroundColor={colors.backgroundHighlightPrimary}
          icon={<AlertLoudIcon fillColor={colors.iconActive} />}
          textColor={colors.textActive}
        />
      )}
    </View>
  )
}
